module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDExIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMC41NjE3NzMgNC40MzQ4NkMtMC4xMTY1NDYgNS4wMTI0MyAwLjM2Mzg2NyA2IDEuMzIzMTYgNkg5LjgyOUMxMC43ODgzIDYgMTEuMjY4NyA1LjAxMjQzIDEwLjU5MDQgNC40MzQ4Nkw2LjMzNzQ2IDAuODEzNTc4QzUuOTE2OTYgMC40NTU1MyA1LjIzNTE5IDAuNDU1NTMgNC44MTQ2OSAwLjgxMzU3N0wwLjU2MTc3MyA0LjQzNDg2WiIgZmlsbD0iI0FEQURBRCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/arrow.svg
// module id = KPAv
// module chunks = 0